// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3xgGN","dragIcon":"SortableItem_dragIcon__ewPoa","disabled":"SortableItem_disabled__73Prk"};